import { useLang } from '../i18n';
import { useCurrency } from '../utils/currency';
import { PriceOnRequest } from './PriceOnRequest';

/**
 * Approved public EUR price shown in the visitor's selected currency.
 * - Converted values are always labelled as estimates until the final quotation.
 * - If no reliable rate exists, the original EUR price is shown untouched.
 * - Products without an approved public price keep the "Price on Request" state.
 */
export const EstimatePrice = ({ amountEur, suffix = '', compact = false, testid = 'estimate-price' }) => {
  const { t, lang } = useLang();
  const { formatMoney } = useCurrency();
  if (amountEur === null || amountEur === undefined || amountEur === '') {
    return <PriceOnRequest compact={compact} testid={testid} />;
  }
  const { text, estimate, fellBack } = formatMoney(amountEur, lang);
  return (
    <span data-testid={testid} className="inline-flex flex-wrap items-baseline gap-1.5">
      <strong className="eco-number text-eco-green">{text}</strong>
      {suffix && <span className="text-sm font-normal text-eco-ink/50">{suffix}</span>}
      {estimate && <span data-testid={`${testid}-estimate`} className="text-[11px] font-medium text-eco-ink/45">({t('cur.estimate')})</span>}
      {fellBack && <span data-testid={`${testid}-eur-fallback`} className="text-[11px] font-medium text-eco-ink/45">({t('cur.original')})</span>}
    </span>
  );
};
